export const GET_PATIENT_PROGRAMS = '@program/GET_PATIENT_PROGRAMS';
export const GET_PATIENT_PROGRAMS_SUCCESS = '@program/GET_PATIENT_PROGRAMS_SUCCESS';
export const GET_PATIENT_PROGRAMS_FAIL = '@program/GET_PATIENT_PROGRAMS_FAIL';
